<template>
    <v-container id="listadocomprobantes-ivt">
      <v-row class="text-center">
        <v-col cols="12">
          <v-card class="alineacentro DatosMatriculado">
            <v-card-title class="DatosMatriculado">
              <v-row class="text-center">
                <v-col cols="12">
                  <v-card
                    dark
                    color="success"
                    class="alineacentro DatosMatriculado"
                  >
                    <strong>REPORTE DE COMPROBANTES</strong>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-title>
            <v-card-text>
              <v-row dense>
                <v-col>
                  <v-spacer />
                </v-col>
              </v-row>
              <v-row class="text-center">
                <v-col cols="12" md="3" lg="3">
                  <v-select
                    v-model="filtros.tipocomprobante"
                    :items="listatiposcomprobantes"
                    label="Tipo Comp"
                    item-text="tipo"
                    item-value="idtipo"
                    height="20px"
                  />
                </v-col>
                <v-col cols="12" md="3" lg="3">
                  <v-select
                    v-model="filtros.anio"
                    :items="listaanios"
                    label="Año"
                    item-text="anio"
                    item-value="anio"
                    height="20px"
                  />
                </v-col>
                <v-col cols="12" md="3" lg="3">
                  <v-select
                    v-model="filtros.mes"
                    :items="listameses"
                    label="Mes"
                    item-text="mes"
                    item-value="nromes"
                    height="20px"
                  />
                </v-col>
                <v-col cols="12" md="3" lg="3">
                  <v-menu
                    v-model="menufecha"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="fechalocal"
                        label="Fecha"
                        prepend-icon="mdi-calendar"
                        v-bind="attrs"
                        v-on="on"
                        height="20px"
                        readonly
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="filtros.fecha"
                      @input="menufecha = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
              <v-row class="text-center">
                <v-col cols="12" md="8" lg="8">
                  <selector-alumno
                    ref="selalumnofiltro"
                    class="alineaizquierda"
                    :nivel=0
                    :habilitado="false"
                    @selAlumno="asignaalumnofiltro"
                  ></selector-alumno>
                </v-col>
                <v-col cols="12" md="4" lg="4">
                  <v-text-field
                    v-model="filtros.persona"
                    label="Persona"
                    height="20px"
                  />
                </v-col>
              </v-row>
              <v-row class="text-center">
                <v-col cols="12" md="3" lg="3">
                  <v-select
                    v-model="idnivel"
                    :items="listaniveles"
                    label="Nivel"
                    item-text="nivel"
                    item-value="idnivel"
                    height="20px"
                    v-on:change="seleccionanivel"
                  />
                </v-col>
                <v-col cols="12" md="9" lg="9">
                  <v-text-field
                    v-model="filtros.concepto"
                    label="Concepto"
                    height="20px"
                  />
                </v-col>
              </v-row>
              <v-row class="text-center" v-if="idnivel>0">
                <v-col v-if="idnivel===4" cols="12" md="5" lg="5">
                  <v-select
                    v-model="filtros.idcarrera"
                    :items="listacarreras"
                    label="Carrera"
                    item-text="carrera"
                    item-value="idcarrera"
                    height="20px"
                    v-on:change="seleccionacarrera"
                  />
                </v-col>
                <v-col cols="12" md="2" lg="2">
                  <v-select
                    v-model="aniocursada"
                    :items="listaanioscursada"
                    label="Año Cursada"
                    item-text="anio"
                    item-value="anio"
                    height="20px"
                    v-on:change="seleccionaaniocursada"
                  />
                </v-col>
                <v-col cols="12" :md="idnivel===4 ? '5' : '10'" :lg="idnivel===4 ? '5' : '10'">
                  <v-select
                    v-model="filtros.iddivision"
                    :items="listadivisiones"
                    label="División"
                    item-text="divisioncompleta"
                    item-value="iddivision"
                    height="20px"
                    v-on:change="Listar"
                  />
                </v-col>
              </v-row>
              <v-row class="text-center">
                <v-col cols="12" md="3" lg="3">
                  <v-select
                    v-model="formatosel"
                    :items="listaformatos"
                    label="Formato"
                    item-text="formato"
                    item-value="formato"
                    height="20px"
                  />
                </v-col>
                <v-col cols="12" md="9" lg="9" class="alineaizquierda">
                  <v-btn
                    class="ma-2"
                    dark
                    x-small
                    color="primary"
                    title="Listar"
                    @click="Listar"
                    :disabled="!permisolectura"
                  >
                    <v-icon dark> mdi-magnify </v-icon>
                  </v-btn>
                  <v-btn
                    class="ma-2"
                    dark
                    x-small
                    color="success"
                    title="Imprimir"
                    @click="ImprimirListado"
                    :disabled="!permisolectura || lista.length===0"
                  >
                    <v-icon dark> mdi-printer </v-icon>
                  </v-btn>
                </v-col>
              </v-row>
              <v-row class="text-center" v-if="lista.length>0">
                <v-col cols="12">
                  <v-data-table
                    :headers="columnas"
                    :items="lista"
                    :items-per-page="10"
                    :footer-props="{
                        'items-per-page-text': 'Filas por Página:',
                        'items-per-page-all-text': 'Todos',
                    }"
                    class="elevation-1"
                    dense
                    no-data-text="Sin Registros"
                    multi-sort
                  >
                  </v-data-table>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-dialog v-model="dialogmensaje" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">
            {{ mensajetitulo }}
          </v-card-title>
          <v-card-text>
            {{ mensajecuerpo }}
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
                color="green darken-1"
                text
                @click="
                dialogmensaje = false;
                if (mensajehome === true) {
                    $router.push('Home');
                }
                "
            >
                Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="loading" full-width>
        <v-container
          fluid
          class="full-height"
          style="background-color: rgba(255, 255, 255, 0.5)"
        >
          <v-row
            align="center"
            justify="center"
            style="height: 100vh"
            no-gutters
            dense
          >
            <v-col class="elementocentrado">
              <v-progress-circular indeterminate color="primary" />
            </v-col>
          </v-row>
        </v-container>
      </v-dialog>
      <ConfirmDlg ref="confirm" />
    </v-container>
</template>
<script>
import axios from "@/axios";
import ConfirmDlg from "../Confirm.vue";
import SelectorAlumno from "../../components/SelectorAlumno.vue";
export default {
  name: "listadocomprobantes",
  components: {
    ConfirmDlg: ConfirmDlg,
    SelectorAlumno: SelectorAlumno
  },
  data() {
    return {
      loading: false,
      usuario: '',
      permisolectura: false,
      permisoescritura: false,
      idrol: 0,
      roles: [],
      nromodulo: 11,
      dialogmensaje: false,
      mensajetitulo: '',
      mensajecuerpo: '',
      mensajehome: false,
      menufecha: false,
      filtros: {
        tipocomprobante: 0,
        anio: 0,
        mes: 0,
        fecha: '',
        idalumno: 0,
        persona: '',
        concepto: '',
        idcarrera: 0,
        iddivision: 0
      },
      listatiposcomprobantes: [
        {idtipo: 0, tipo: 'TODOS'},
        {idtipo: 1, tipo: 'FACTURAS'},
        {idtipo: 2, tipo: 'RECIBOS'},
        {idtipo: 3, tipo: 'NOTA DE CRED.'}
      ],
      listaanios: [],
      listameses: [
        {nromes: 0, mes:'Todos'},
        {nromes: 1, mes:'Enero'},
        {nromes: 2, mes:'Febrero'},
        {nromes: 3, mes:'Marzo'},
        {nromes: 4, mes:'Abril'},
        {nromes: 5, mes:'Mayo'},
        {nromes: 6, mes:'Junio'},
        {nromes: 7, mes:'Julio'},
        {nromes: 8, mes:'Agosto'},
        {nromes: 9, mes:'Septiembre'},
        {nromes: 10, mes:'Octubre'},
        {nromes: 11, mes:'Noviembre'},
        {nromes: 12, mes:'Diciembre'}
      ],
      listaformatos: [
        {formato: 'PDF'},
        {formato: 'EXCEL'},
      ],
      formatosel: 'PDF',
      lista: [],
      columnas: [
        {
          text: "Tipo",
          align: "center",
          sortable: true,
          value: "tipocomprobante",
          width: 80,
        },
        {
          text: "N° Comp",
          align: "center",
          sortable: true,
          value: "nrocomprobante",
          width: 140,
        },
        {
          text: "Fecha",
          align: "center",
          sortable: true,
          value: "fechaemision",
          width: 75,
        },
        {
          text: "Hora",
          align: "center",
          sortable: true,
          value: "horaemision",
          width: 75,
        },
        {
          text: "Concepto",
          align: "center",
          sortable: true,
          value: "concepto",
          width: 140,
        },
        {
          text: "Alumno",
          align: "center",
          sortable: true,
          value: "alumno",
          width: 120,
        },
        {
          text: "Localidad",
          align: "center",
          sortable: true,
          value: "localidadalumno",
          width: 130,
        },
        {
          text: "Per. Fac.",
          align: "center",
          sortable: true,
          value: "personafactura",
          width: 120,
        },
        {
          text: "Monto",
          align: "center",
          sortable: true,
          value: "monto",
          width: 100,
        },
        {
          text: "Estado",
          align: "center",
          sortable: true,
          value: "estado",
          width: 100,
        },
        {
          text: "CAE",
          align: "center",
          sortable: true,
          value: "cae",
          width: 70,
        },
        {
          text: "ReFac",
          align: "center",
          sortable: true,
          value: "refacturada",
          width: 95,
        },
        {
          text: "N° Com Ant",
          align: "center",
          sortable: true,
          value: "nrocomprobanteanterior",
          width: 140,
        },
        {
          text: "ID PF",
          align: "center",
          sortable: true,
          value: "idpagofacil",
          width: 100,
        },
        {
          text: "Usuario",
          align: "center",
          sortable: true,
          value: "usuario",
          width: 110,
        }
      ],
      listaniveles: [
        {idnivel: 0, nivel: 'TODOS'},
        {idnivel: 1, nivel: 'Inicial'},
        {idnivel: 2, nivel: 'Primario'},
        {idnivel: 3, nivel: 'Secundario'},
        {idnivel: 4, nivel: 'Superior'}
      ],
      listacarreras: [],
      listaanioscursada: [],
      listadivisiones: [],
      aniocursada: 0,
      idnivel: 0
    };
  },
  mounted() {
    this.loading = true;
    this.roles=[];
    this.usuario = localStorage.getItem("user");
    var permisos = JSON.parse(localStorage.getItem("permisos"));
    var rolesuser = localStorage.getItem("rolesuserid").split(',');
    rolesuser.forEach((elemento) => {
        this.roles.push(parseInt(elemento));
    });
    var existeper = permisos.filter((p) => p.nromodulo === this.nromodulo && (this.roles.includes(p.idrol) || p.usuario === this.usuario) && p.idaccion === 1);
    if (existeper.length === 0) {
        this.loading = false;
        this.MostrarMensaje("Error","No tiene permisos para acceder a este módulo.",true);
    } else {
        this.permisolectura = permisos.filter((p) => p.nromodulo === this.nromodulo && (this.roles.includes(p.idrol) || p.usuario === this.usuario) && p.idaccion === 2).length > 0 ? true : false;
        this.permisoescritura = permisos.filter((p) => p.nromodulo === this.nromodulo && (this.roles.includes(p.idrol) || p.usuario === this.usuario) && p.idaccion === 3).length > 0 ? true : false;
        var i=0;
        var anioactual= (new Date()).getFullYear();
        for(i=2023;i<=anioactual+1;i++){
            this.listaanios.push({anio: i});
        }
        this.filtros.anio= anioactual;
        var ia= 2023;
        this.listaanioscursada=[];
        for(ia=2023; ia<=anioactual;ia++){
          this.listaanioscursada.push({anio: ia});
        }
        if(this.listaanioscursada.length>0) {
          this.aniocursada=anioactual;
        }
        this.cargacombos();
    }
  },
  methods: {
    cargacombos () {
      axios.post("inscripcioncarrera/PostCarrerasTodas", { headers: { "Content-Type": "application/json",}}).then((result) => {
        if(result.data.resultado===0){
          this.listacarreras = this.idnivel>0 ? result.data.datos.filter(c=> c.idnivel==this.idnivel) : result.data.datos;
          this.filtros.idcarrera= this.idnivel>0 ? this.listacarreras.length>0 ? this.listacarreras[0].idcarrera : 0 : 0;
          axios.get("curso/ListaDivisiones/" + this.filtros.idcarrera.toString() + "/" + this.aniocursada.toString()).then((result) => {
            if(result.data.resultado===0) {
              this.listadivisiones = result.data.datos;
              if(this.listadivisiones.length>0){
                this.filtros.iddivision= this.listadivisiones[0].iddivision;
              }
              this.loading = false;
            }else{
              this.loading = false;
              this.MostrarMensaje('Error', result.data.resultadomensaje, false);
            }
          }).catch((error) => {
            this.loading = false;
            this.MostrarMensaje('Error', error, false);
          });
        }else{
          this.loading = false;
          this.MostrarMensaje('Error', result.data.resultadomensaje, false);
        }
      }).catch((error) => {
        this.loading = false;
        this.MostrarMensaje('Error', error, false);
      });
      this.loading= false;
    },
    MostrarMensaje(titulo, cuerpo, home) {
      this.mensajetitulo = titulo;
      this.mensajecuerpo = cuerpo;
      this.mensajehome = home != null ? home : false;
      this.dialogmensaje = true;
    },
    fechaFormatoYMD(date) {
      return (date.getFullYear() + "-" + ((date.getMonth() + 1).toString().length != 2 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1) + "-" + (date.getDate().toString().length != 2 ? "0" + date.getDate() : date.getDate()));
    },
    ImprimirListado () {
      this.loading = true;
      var per= this.filtros.persona!=null ? this.filtros.persona : '';
      var conc= this.filtros.concepto!=null ? this.filtros.concepto : '';
      axios.post("reportes/GetReporte",
        {idreporte: 6, formato: this.formatosel, nromodulo: parseInt(this.nromodulo), usuario: this.usuario.toString(), listaparametros: [{ orden: 1, nombre: "tipocomprobante", valor: this.filtros.tipocomprobante.toString()}, { orden: 2, nombre: "anio", valor: this.filtros.anio.toString()}, { orden: 3, nombre: "mes", valor: this.filtros.mes.toString()},{ orden: 4, nombre: "fecha", valor: this.filtros.fecha},{ orden: 5, nombre: "idalumno", valor: this.filtros.idalumno.toString()},{ orden: 6, nombre: "persona", valor: per},{ orden: 7, nombre: "concepto", valor: conc},{ orden: 8, nombre: "idcarrera", valor: this.filtros.idcarrera.toString()},{ orden: 9, nombre: "iddivision", valor: this.filtros.iddivision.toString()} ] },{ headers: { "Content-Type": "application/json" }})
        .then((result) => {
          this.loading = false;
          if (result.data.toString().startsWith("Error") === false) {
            window.open(result.data, "_blank");
          } else {
            this.MostrarMensaje("Error", result.data, false);
          }
        }).catch((error) => {
          this.loading = false;
          this.MostrarMensaje("Error", error, false);
        });
    },
    asignaalumnofiltro (value) {
      if(value!=null){
        this.filtros.idalumno= value.idalumno;
      }else{
        this.filtros.idalumno= 0;
      }
    },
    Listar () {
      this.loading= true;
      this.filtros.persona= this.filtros.persona!=null ? this.filtros.persona : '';
      this.filtros.concepto= this.filtros.concepto!=null ? this.filtros.concepto : '';
      const filtro = JSON.stringify(this.filtros);
      axios.post("contable/PostListaComprobantes", filtro, { headers: { "Content-Type": "application/json" }}).then((result) => {
        if(result.data.resultado===0){
          this.lista = result.data.datos;
          this.loading = false;
        }else{
          this.loading = false;
          this.MostrarMensaje("Error", result.data.resultadomensaje, false);
        }
      }).catch((error) => {
        this.loading = false;
        this.MostrarMensaje("Error", error, false);
      });
    },
    seleccionanivel () {
      this.loading=true;
      if(this.idnivel===0){
        this.filtros.idcarrera=0;
        this.filtros.iddivision=0;
      }
      this.cargacombos();
    },
    seleccionacarrera () {
      this.loading=true;
      axios.get("curso/ListaDivisiones/" + this.filtros.idcarrera.toString() + "/" + this.aniocursada.toString()).then((result) => {
        if(result.data.resultado===0) {
          this.listadivisiones = result.data.datos;
          if(this.listadivisiones.length>0){
            this.filtros.iddivision= this.listadivisiones[0].iddivision;
          }
          this.loading = false;
        }else{
          this.loading = false;
          this.MostrarMensaje('Error', result.data.resultadomensaje, false);
        }
      }).catch((error) => {
        this.loading = false;
        this.MostrarMensaje('Error', error, false);
      });
    },
    seleccionaaniocursada () {
      this.loading=true;
      axios.get("curso/ListaDivisiones/" + this.filtros.idcarrera.toString() + "/" + this.aniocursada.toString()).then((result) => {
        if(result.data.resultado===0) {
          this.listadivisiones = result.data.datos;
          if(this.listadivisiones.length>0){
            this.filtros.iddivision= this.listadivisiones[0].iddivision;
          }
          this.loading = false;
        }else{
          this.loading = false;
          this.MostrarMensaje('Error', result.data.resultadomensaje, false);
        }
      }).catch((error) => {
        this.loading = false;
        this.MostrarMensaje('Error', error, false);
      });
    }
},
  computed: {
    fechalocal: function () {
      if (this.filtros.fecha != null && this.filtros.fecha != "") {
        var fecha = new Date(this.filtros.fecha);
        fecha.setDate(fecha.getDate() + 1);
        return fecha.toLocaleDateString("es-AR");
      } else {
        return "";
      }
    }
  },
};
</script>
<style>
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td, .v-data-table > .v-data-table__wrapper > table > thead > tr > td, .v-data-table > .v-data-table__wrapper > table > tfoot > tr > td {
    font-size: 0.680rem !important;
    height: 25px !important;
}

.fullpantalla{
    height: 100% !important;
    width: 100% !important;
}

.letraroja {
  color: red;
}
.textocentrado {
  text-align: center;
}
.elementocentrado {
  display: flex;
  justify-content: center;
  align-items: center;
}
.col-xl,
.col-xl-auto,
.col-xl-12,
.col-xl-11,
.col-xl-10,
.col-xl-9,
.col-xl-8,
.col-xl-7,
.col-xl-6,
.col-xl-5,
.col-xl-4,
.col-xl-3,
.col-xl-2,
.col-xl-1,
.col-lg,
.col-lg-auto,
.col-lg-12,
.col-lg-11,
.col-lg-10,
.col-lg-9,
.col-lg-8,
.col-lg-7,
.col-lg-6,
.col-lg-5,
.col-lg-4,
.col-lg-3,
.col-lg-2,
.col-lg-1,
.col-md,
.col-md-auto,
.col-md-12,
.col-md-11,
.col-md-10,
.col-md-9,
.col-md-8,
.col-md-7,
.col-md-6,
.col-md-5,
.col-md-4,
.col-md-3,
.col-md-2,
.col-md-1,
.col-sm,
.col-sm-auto,
.col-sm-12,
.col-sm-11,
.col-sm-10,
.col-sm-9,
.col-sm-8,
.col-sm-7,
.col-sm-6,
.col-sm-5,
.col-sm-4,
.col-sm-3,
.col-sm-2,
.col-sm-1,
.col,
.col-auto,
.col-12,
.col-11,
.col-10,
.col-9,
.col-8,
.col-7,
.col-6,
.col-5,
.col-4,
.col-3,
.col-2,
.col-1 {
  padding: 2px !important;
}
@media only screen and (min-width: 960px) {
  .altojusto {
    height: 45px !important;
  }
}
.alineaizquierda {
  text-align: left;
}
.alineacentro {
  text-align: center;
}
.alineaderecha {
  text-align: right;
}
.ocupa30 {
  width: 30%;
}
.ocupa50 {
  width: 50%;
}
.ocupa75 {
  width: 75%;
}
.ocupa95 {
  width: 95%;
}
.centradovertical {
  vertical-align: middle;
  align-items: center;
}
.abajovertical {
  vertical-align: bottom;
}
.TituloGrilla {
  font-family: Tahoma;
  font-size: medium;
  font-weight: bold;
  background-color: darkgray;
}
.textoNegritaRojo {
  color: red !important;
  font-weight: bold !important;
}
.textoNegritaVerde {
  color: rgb(83, 248, 125) !important;
  font-weight: bold !important;
}
</style>